/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext, useEffect, useState } from "react";
import { ListUsersSession } from "./widget/ListUsersSession";
import "./Dashboard.css";
// import "../dashboard/Dashboard.css";
import { useIntl } from "react-intl";
import { getAuth, useAuth } from "../../modules/auth";
import axios from "axios";
import io from "socket.io-client";
import { Toaster } from "react-hot-toast";
import {
  UserAttemptAccessNotification,
  accessNotificationToast,
} from "../../../_metronic/partials/notification-toast/notification-toast";
import { ListUsersLastAttemptsAccess } from "./widget/ListUsersLastAttemptsAccess";
import { ListUserPaymentHistory } from "./widget/ListUserPaymentHistory";
import { KTSVG } from "../../../_metronic/helpers";
import CaixaFooter from "../../components/Caixa/CaixaFooter";
import { CaixaContext } from "../../components/Caixa/CaixaContext_";
import { useOrders } from "../../modules/hooks/useOrders";

interface BraceletColor {
  _id: number;
  name: string;
  color: string;
  visitors: boolean;
}

interface UserBracelet {
  _id: number;
  bracelet_color: BraceletColor;
}

interface DashboardUser {
  _id: number;
  email: string;
  first_name: string;
  last_name: string;
  profile_image: string;
  bracelets: UserBracelet[];
}

interface Section {
  _id: number;
  description: string;
  users: DashboardUser[];
}

interface Location {
  _id: number;
  name: string;
  sections: Section[];
  outside: {
    users: DashboardUser[];
  };
}

export interface LastAttemptAccess {
  origin_section: {
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    _id: number;
    description: string;
  };
  destination_section: {
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    _id: number;
    description: string;
  };
  entrance: {
    _id: number;
    description: string;
  };
  event_giveup: boolean;
  operation: {
    _id: number;
    description: string;
  };
  access: boolean;
  created_at: Date;
  user: {
    _id: number;
    email: string;
    first_name: string;
    last_name: string;
    profile_image: string;
    compliance: boolean;
    overdue: boolean;
    status: {
      _id: number;
      description: string;
    };
    bracelets: [
      {
        created_at: Date;
        updated_at: Date;
        deleted_at: Date;
        _id: number;
        _id_company: number;
        _id_bracelet_color: number;
        content: string;
        master: boolean;
        bracelet_color: {
          created_at: Date;
          updated_at: Date;
          deleted_at: Date;
          _id: number;
          name: string;
          color: string;
          visitors: boolean;
          status: {
            _id: number;
            description: string;
          };
        };
        access: {
          _id_user: number;
          latest_updated_at: Date;
          _id_bracelet: number;
          _id_destination_section: number;
        };
      }
    ];
  };
}

const Dashboard: FC = () => {
  const intl = useIntl();
  const [locations, setLocations] = useState<Location[]>([]);
  const [lastAttemptsAccess, setLastAttemptsAccess] = useState<
    LastAttemptAccess[]
  >([]);

  const [inputVisible, setInputVisible] = useState(false);
  const [inputVisible2, setInputVisible2] = useState(false);

  const { userData } = useOrders();
  const toggleInputVisibility = () => {
    setInputVisible(!inputVisible);
  };

  const toggleInputVisibility2 = () => {
    setInputVisible2(!inputVisible2);
  };

  const loadDashboardData = async () => {
    const apiToken = getAuth();
    const token = apiToken?.api_token;
    const apiUrl = process.env.REACT_APP_API_URL;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    if (apiToken) {
      try {
        const response = await axios.get(`${apiUrl}/access/dashboard`, {
          headers,
        });

        return response.data;
      } catch (error) {
        console.error(error);
      }
    }
  };

  const { currentUser } = useAuth();
  const { verificaCaixaAberto } = useContext(CaixaContext);

  useEffect(() => {
    loadDashboardData().then((response) => {
      setLocations(response?.locations);
      setLastAttemptsAccess(response?.lastAttemptsAccess);
    });

    const socket = io(process.env.REACT_APP_API_URL ?? "");

    const handleAttemptAccessNotification = (
      accessNotification: UserAttemptAccessNotification
    ) => {
      accessNotificationToast(accessNotification, true, false, false);

      loadDashboardData().then((response) => {
        setLocations(response?.locations);
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleAccessNotification = (
      accessNotification: UserAttemptAccessNotification
    ) => {
      accessNotificationToast(accessNotification, false, true, false);

      loadDashboardData().then((response) => {
        setLocations(response?.locations);
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleGiveUpAccessNotification = (
      accessNotification: UserAttemptAccessNotification
    ) => {
      accessNotificationToast(accessNotification, false, false, true);

      loadDashboardData().then((response) => {
        setLocations(response?.locations);
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleVisitorCreationNotification = () => {
      loadDashboardData().then((response) => {
        setLocations(response?.locations);
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    const handleTopbarNotification = () => {
      loadDashboardData().then((response) => {
        setLocations(response?.locations);
        setLastAttemptsAccess(response?.lastAttemptsAccess);
      });
    };

    verificaCaixaAberto();

    socket.on(
      `attemptAccessNotification${currentUser?._id_company}`,
      handleAttemptAccessNotification
    );
    socket.on(
      `accessNotification${currentUser?._id_company}`,
      handleAccessNotification
    );
    socket.on(
      `giveUpAccessNotification${currentUser?._id_company}`,
      handleGiveUpAccessNotification
    );
    socket.on(
      `visitorCreationNotification${currentUser?._id_company}`,
      handleVisitorCreationNotification
    );
    socket.on(
      `topbarNotification${currentUser?._id_company}`,
      handleTopbarNotification
    );

    return () => {
      socket.off(
        `attemptAccessNotification${currentUser?._id_company}`,
        handleAttemptAccessNotification
      );
      socket.off(
        `accessNotification${currentUser?._id_company}`,
        handleAccessNotification
      );
      socket.off(
        `giveUpAccessNotification${currentUser?._id_company}`,
        handleGiveUpAccessNotification
      );
      socket.off(
        `visitorCreationNotification${currentUser?._id_company}`,
        handleVisitorCreationNotification
      );
      socket.off(
        `topbarNotification${currentUser?._id_company}`,
        handleTopbarNotification
      );

      socket.disconnect();
    };
  }, [currentUser]);

  const [searchTerm, setSearchTerm] = useState<string>("");

  const filterUsers = (users: DashboardUser[]) => {
    if (!searchTerm) return users;
    return users.filter((user) =>
      user.first_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <div className="d-flex flex-column h-100">
      <div
        className="collapse input-group mb-3"
        id="collapseExample"
        style={{ transition: "0.5s" }}
      >
        <input
          type="text"
          placeholder="Filtrar usuários..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control mb-3"
        />
      </div>

      <div className="d-flex flex-column justify-content-between h-100">
        {locations.map((location, indexLocation) => (
          <div
            className="d-flex flex-wrap justify-content-center"
            key={indexLocation}
          >
            {location.sections.map((section, indexSection) => (
              <div
                className="accordion col-12 col-sm-6 col-md-3 p-1"
                key={indexSection}
              >
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id={`heading-location-${indexLocation}-section-${indexSection}`}
                  >
                    <button
                      className="accordion-button collapsed bg-black border-bottom border-silver d-flex justify-content-between align-items-center p-4"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-location-${indexLocation}-section-${indexSection}`}
                    >
                      <span className="mx-auto p-1">
                        {section?.description}
                      </span>
                      <span
                        id="visualizar"
                        className="badge bg-gray-600"
                        data-bs-toggle="collapse"
                        data-bs-target={`#heading-location-${indexLocation}-section-${indexSection} .player-cols`}
                      >
                        {filterUsers(section?.users).length}
                      </span>
                      <div className="col player-cols collapse">
                        <div
                          className="d-flex align-items-center flex-column"
                          title={intl.formatMessage({
                            id: "MENU.HEADER.GROUPS.PRESENT",
                          })}
                        >
                          <i
                            className="fas fa-users"
                            style={{ color: "#00FF5F" }}
                          ></i>
                          <label>
                            {section?.users?.filter(
                              (user) =>
                                !user?.bracelets?.some(
                                  (bracelet) =>
                                    bracelet?.bracelet_color?.visitors
                                )
                            )?.length || 0}
                          </label>
                        </div>
                      </div>
                      <div className="col player-cols collapse">
                        <div
                          className="d-flex align-items-center flex-column"
                          title={intl.formatMessage({
                            id: "MENU.HEADER.GROUPS.VISITORS",
                          })}
                        >
                          <i
                            className="fas fa-users"
                            style={{ color: "#fff" }}
                          ></i>
                          <label>
                            {section?.users?.filter((user) =>
                              user?.bracelets?.some(
                                (bracelet) => bracelet?.bracelet_color?.visitors
                              )
                            )?.length || 0}
                          </label>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* begin::ListUser */}
                  <div
                    id={`collapse-location-${indexLocation}-section-${indexSection}`}
                    className="accordion-collapse collapse"
                  >
                    <div className="accordion p-1">
                      <ListUsersSession users={filterUsers(section?.users)} />
                    </div>
                    {/* End::ListUser */}
                  </div>
                </div>
              </div>
            ))}

            <div className="accordion col-12 col-sm-6 col-md-3 p-1">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id={`heading-location-${indexLocation}-outside`}
                >
                  <button
                    className="accordion-button collapsed bg-black border-bottom border-silver d-flex justify-content-between align-items-center p-4"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-location-${indexLocation}-outside`}
                  >
                    <span className="mx-auto p-1">Cadastrados</span>
                    <span
                      id="visualizar"
                      className="badge bg-gray-600"
                      data-bs-toggle="collapse"
                      data-bs-target={`#heading-location-${indexLocation}-outside .player-cols`}
                    >
                      {filterUsers(location?.outside.users).length}
                    </span>
                    <div className="col player-cols collapse">
                      <div
                        className="d-flex align-items-center flex-column"
                        title={intl.formatMessage({
                          id: "MENU.HEADER.GROUPS.PRESENT",
                        })}
                      >
                        <i
                          className="fas fa-users"
                          style={{ color: "#00FF5F" }}
                        ></i>
                        <label>
                          {userData?.filter(
                            (user: any) =>
                              !user?.bracelets?.some(
                                (bracelet: any) =>
                                  bracelet?.bracelet_color?.visitors
                              )
                          )?.length || 0}
                        </label>
                      </div>
                    </div>
                    <div className="col player-cols collapse">
                      <div
                        className="d-flex align-items-center flex-column"
                        title={intl.formatMessage({
                          id: "MENU.HEADER.GROUPS.VISITORS",
                        })}
                      >
                        <i
                          className="fas fa-users"
                          style={{ color: "#fff" }}
                        ></i>
                        <label>
                          {userData?.filter((user: any) =>
                            user?.bracelets?.some(
                              (bracelet: any) =>
                                bracelet?.bracelet_color?.visitors
                            )
                          )?.length || 0}
                        </label>
                      </div>
                    </div>
                  </button>
                </h2>
                <div
                  id={`collapse-location-${indexLocation}-outside`}
                  className="accordion-collapse collapse"
                >
                  <div className="accordion p-1">
                    <ListUsersSession
                      users={filterUsers(location?.outside.users)}
                    />
                  </div>
                  {/* End::ListUser */}
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="d-flex flex-wrap">
          {/* begin::Col */}
          <div className="accordion col-12 col-12 col-sm-6 p-2">
            <div className="accordion-item  text-center">
              <h2 className="accordion-header" id="headingFive">
                <button
                  className="accordion-button bg-black border-bottom border-silver p-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                >
                  <span className="flex-grow-1 ms-5">
                    {intl.formatMessage({
                      id: "DASHBOARD.HISTORYC_PAYMENT",
                    })}
                  </span>
                  <span
                    className="menu-icon me-5 p-2"
                    data-bs-toggle="collapse"
                    onClick={toggleInputVisibility}
                  >
                    <KTSVG
                      path="/media/icons/duotune/general/gen004.svg"
                      className="svg-icon-1 text-white"
                    />
                  </span>
                </button>
              </h2>

              {/* begin::ListUser */}
              <div id="collapseTwo" className="accordion-collapse collapse">
                <div className="accordion p-3 pe-1 ps-1">
                  <ListUserPaymentHistory inputVisible={inputVisible} />
                </div>
              </div>
              {/* end::ListUser */}
            </div>
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className="accordion col-12 col-12 col-sm-6 p-2">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSix">
                <button
                  className="accordion-button bg-black border-bottom border-silver p-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                >
                  <span className="flex-grow-1 ms-5">
                    {intl.formatMessage({
                      id: "DASHBOARD.HISTORYC_INPUT",
                    })}
                  </span>
                  <span
                    className="menu-icon me-5 p-2"
                    data-bs-toggle="collapse"
                    onClick={toggleInputVisibility2}
                  >
                    <KTSVG
                      path="/media/icons/duotune/general/gen004.svg"
                      className="svg-icon-1 text-white"
                    />
                  </span>
                </button>
              </h2>

              {/* begin::ListUser */}
              <div id="collapseTwo" className="accordion-collapse collapse">
                <div className="accordion p-1 overflow-x-scroll">
                  <ListUsersLastAttemptsAccess
                    lastAttemptsAccess={lastAttemptsAccess}
                    inputVisible2={inputVisible2}
                  />
                </div>
              </div>
              {/* end::ListUser */}
            </div>
          </div>
          {/* end::Col */}
        </div>

        <Toaster position="bottom-right" reverseOrder={false} />
      </div>
    </div>
  );
};

export { Dashboard };
